<div class="card card-transaction {{trend?.class}}">
    <div class="card-header">
        <div class="d-flex flex-column w-100">
            <div class="d-flex">
              <h6>{{trend?.title}}</h6>
            </div>
            <p class="mb-0">
              <small>{{trend?.tooltip}}</small>
            </p>
        </div>
    </div>
    <div class="card-body">
      <table class="w-100 trend-table">
        <tr>
          <th class="text-left"> {{type =='crypto' ? 'Crypto' : 'Company'}} </th>
          <th *ngIf="trend?.signal" class="text-center"> Sentiment </th>
          <th *ngIf="trend?.bullBearRatio" class="text-center"> Bull/Bear </th>
          <th *ngIf="trend?.volume" class="text-center"> Posts </th>
          <th *ngIf="trend?.volumeChange" class="text-center"> % Change </th>
          <!-- <th *ngIf="trend?.mentions" [ngClass]="{'text-center': key != 'reddit', 'text-right': key == 'reddit'}" class="text-center"> Mentions </th> -->
          <th *ngIf="trend?.volumeIncrease" class="text-right"> % Change </th>
        </tr>
        <tr *ngFor="let ticker of trend?.topTwentyTickers; index as i" (click)="openModal(ticker)">
          <td class="pt-2">
            <div class="media align-items-center">
              <div class="avatar bg-light-primary rounded">
                  <div class="avatar-content">
                    <ng-container *ngIf="this.type == 'stock'">
                      <img src="assets/images/ticker-icons/{{ticker.toString().toUpperCase()}}.png" width="28" height="28" />
                    </ng-container>
                    <ng-container *ngIf="this.type == 'crypto'">
                      <img src="assets/images/crypto-icons/{{ticker.toString().toUpperCase()}}.jpg" width="28" height="28" />
                    </ng-container>
                  </div>
              </div>
              <div class="media-body">
                  <h6 class="transaction-title ml-1 mb-0">{{ticker | uppercase}}</h6>
              </div>
            </div>
          </td>
          <td class="pt-2" *ngIf="trend?.signal">
            <ng-container *ngTemplateOutlet="sentimentValue; context: { value: trend?.signal[i].toUpperCase() }"></ng-container>
          </td>
          <td class="pt-2" *ngIf="trend?.bullBearRatio">
            <ng-container *ngTemplateOutlet="bearbullValue; context: { value: trend?.bullBearRatio[i] }"></ng-container>
          </td>
          <td class="pt-2" *ngIf="trend?.volume">
            <ng-container *ngTemplateOutlet="redditValue; context: { value: trend?.volume[i] }"></ng-container>
          </td>
          <td class="pt-2" *ngIf="trend?.volumeChange">
            <ng-container *ngTemplateOutlet="volchangeValue; context: { value: trend?.volumeChange[i] }"></ng-container>
          </td>
          <td class="pt-2" *ngIf="trend?.volumeIncrease">
            <ng-container *ngTemplateOutlet="valueTemp; context: { value: trend?.volumeIncrease[i] }"></ng-container>
          </td>
          <!-- <td class="pt-2" *ngIf="trend?.mentions">
            <ng-container *ngTemplateOutlet="mentionValue; context: { value: trend?.mentions[i] }"></ng-container>
          </td> -->
        </tr>
      </table>
        <!-- <div class="transaction-item cursor-pointer" *ngFor="let ticker of trend?.topTwentyTickers; index as i" (click)="openModal(ticker)">
            <div class="media w-100">
                <div class="avatar bg-light-primary rounded">
                    <div class="avatar-content">
                        <img src="assets/images/ticker-icons/{{ticker.toString().toUpperCase()}}.png" width="28" height="28" />
                    </div>
                </div>
                <div class="media-body">
                    <h6 class="transaction-title">{{ticker | uppercase}}</h6>
                </div>
            </div>

          <ng-container *ngIf="trend?.mentions">
              <ng-container *ngTemplateOutlet="redditValue; context: { value: trend?.mentions[i] }"></ng-container>
          </ng-container>

          <ng-container *ngIf="trend?.signal">
            <ng-container *ngTemplateOutlet="sentimentValue; context: { value: trend?.signal[i].toUpperCase() }"></ng-container>
          </ng-container>

          <ng-container *ngIf="trend?.bullBearRatio">
            <ng-container *ngTemplateOutlet="bearbullValue; context: { value: trend?.bullBearRatio[i] }"></ng-container>
          </ng-container>

          <ng-container *ngIf="trend?.volume">
              <ng-container *ngTemplateOutlet="redditValue; context: { value: trend?.volume[i] }"></ng-container>
          </ng-container>

          <ng-container *ngIf="trend?.volumeChange">
            <ng-container *ngTemplateOutlet="volchangeValue; context: { value: trend?.volumeChange[i] }"></ng-container>
          </ng-container>

          <ng-container *ngIf="trend?.volumeIncrease">
            <ng-container *ngTemplateOutlet="valueTemp; context: { value: trend?.volumeIncrease[i] }"></ng-container>
          </ng-container>
        </div> -->
    </div>
</div>


<ng-template #valueTemp let-value="value">
    <div class="font-weight-bolder text-right" [ngClass]="{'text-danger': value < 0, 'text-success': value > 0}"> {{value > 0 ? '+':null}}{{roundOf(value * 100)}}%</div>
</ng-template>
<ng-template #volchangeValue let-value="value">
  <div class="font-weight-bolder text-center" [ngClass]="{'text-danger': value < 0, 'text-success': value > 0}"> {{value > 0 ? '+':null}}{{roundOf(value)}}%</div>
</ng-template>
<!-- mentions -->
<ng-template #mentionValue let-value="value">
  <div class="font-weight-bolder text-right" [ngClass]="{'text-danger': value < 0, 'text-success': value > 0}"> {{value}}</div>
</ng-template>
<!-- reddit -->
<ng-template #redditValue let-value="value">
    <div class="font-weight-bolder text-center" [ngClass]="{'text-danger': value < 0, 'text-success': value > 0}"> {{value}}</div>
</ng-template>

<!-- reddit -->
<ng-template #sentimentValue let-value="value">
  <div class="font-weight-bolder text-center" [ngClass]="{'text-danger': value =='BEAR', 'text-success': value =='BULL'}"> {{value}}</div>
</ng-template>
<ng-template #bearbullValue let-value="value">
  <ng-container *ngIf="value">
    <div class="font-weight-bolder text-center">{{value}}</div>
  </ng-container>
  <ng-container *ngIf="!value">
    <div class="font-weight-bolder text-center">0</div>
  </ng-container>
</ng-template>
